import { gql } from '@apollo/client';

export const CREATE_LEADERSHIP_POST = gql`
    mutation CreateLeadershipPost($title: String!, $description: String!, $type: String!, $imageIds: [Int]) {
        createLeadershipPost(title: $title, description: $description, type: $type, imageIds: $imageIds) {
            ... on LeadershipUpdate {
                id
                title
                description
                type
                images {
                    id
                    url
                }
            }
            ... on LeadershipPrayerRequest {
                id
                title
                description
                type
                images {
                    id
                    url
                }
            }
        }
    }
`;
